var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeskPhoneIcon = function SvgDeskPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 101,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    fillRule: "evenodd",
    d: "M103.5 19.656H38.875V9.375A8.813 8.813 0 0 0 30.063.563H9.5A8.81 8.81 0 0 0 .688 9.375v82.25a8.813 8.813 0 0 0 8.812 8.813h94a8.813 8.813 0 0 0 8.812-8.813V28.469a8.81 8.81 0 0 0-8.812-8.813M35.938 97.5H9.5a5.875 5.875 0 0 1-5.875-5.875V9.375A5.875 5.875 0 0 1 9.5 3.5h20.563a5.875 5.875 0 0 1 5.875 5.875zm73.437-5.875A5.875 5.875 0 0 1 103.5 97.5H38.875V22.594H103.5a5.875 5.875 0 0 1 5.875 5.875zM52.094 62.25h8.812v2.938h-8.812zm17.625 0h8.812v2.938H69.72zm17.625 0h8.812v2.938h-8.812zm-35.25 10.281h8.812v2.938h-8.812zm17.625 0h8.812v2.938H69.72zm17.625 0h8.812v2.938h-8.812zm-35.25 10.281h8.812v2.938h-8.812zm17.625 0h8.812v2.938H69.72zm17.625 0h8.812v2.938h-8.812z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009FDB",
    fillRule: "evenodd",
    d: "M52.094 54.906h44.062V34.344H52.094zm2.937-17.625H93.22V51.97H55.03z",
    clipRule: "evenodd"
  })));
};
export default SvgDeskPhoneIcon;